import { TownNewsPanel } from '../components/town-news-panel';
import { useTownNews } from '../hooks/use-town-news';
import type { NewsLanguage } from '../utils/town-news-copy';
export function TownNewsContainer({npcId, language}: {npcId: number; language: NewsLanguage}) {
  const state = useTownNews(npcId);
  return <TownNewsPanel snapshot={state.snapshot} failed={state.failed} language={language} onRetry={state.retry} />;
}
